// eslint-disable-next-line no-unused-vars
import RedirectMiddleware from '@/middleware/RedirectMiddleware';

export default [
    {
        path: '/',
        name: 'home',
        beforeEnter: (too, from, next) => { RedirectMiddleware(too, from, next); },
        components: {
            default: () => import(/* webpackChunkName: "homepage" */ '@/views/DynamicHome.vue'),
            footer: () => import(/* webpackChunkName: "footer" */ '@/components/structure/Footer'),
            topNavigation: () => import(/* webpackChunkName: "top-navigation" */ '@/components/structure/navigation/TopNavigation'),
        },
        meta: {
            order: 1,
        },
    },
    {
        path: '/v2',
        name: 'v2-home',
        redirect: { name: 'home' },
        props: true,
    },
    {
        path: '/v2/c/:code',
        name: 'v2-coupon',
        redirect: { name: 'coupon' },
        props: true,
    },
    {
        path: '/the-flowers',
        name: 'flowers',
        components: {
            default: () => import(/* webpackChunkName: "landing" */ '@/views/content/LandingPage.vue'),
            footer: () => import(/* webpackChunkName: "footer" */ '@/components/structure/Footer'),
            topNavigation: () => import(/* webpackChunkName: "top-navigation" */ '@/components/structure/navigation/TopNavigation'),
        },
        meta: {
            order: 2,
        },
    },
    {
        path: '/the-delivery',
        name: 'delivery',
        components: {
            default: () => import(/* webpackChunkName: "landing" */ '@/views/content/LandingPage.vue'),
            footer: () => import(/* webpackChunkName: "footer" */ '@/components/structure/Footer'),
            topNavigation: () => import(/* webpackChunkName: "top-navigation" */ '@/components/structure/navigation/TopNavigation'),
        },
        meta: {
            order: 3,
        },
    },
    {
        path: '/the-arranging',
        name: 'arranging',
        components: {
            default: () => import(/* webpackChunkName: "landing" */ '@/views/content/LandingPage.vue'),
            footer: () => import(/* webpackChunkName: "footer" */ '@/components/structure/Footer'),
            topNavigation: () => import(/* webpackChunkName: "top-navigation" */ '@/components/structure/navigation/TopNavigation'),
        },
        meta: {
            order: 4,
        },
    },
    {
        path: '/faq',
        name: 'faq',
        components: {
            default: () => import(/* webpackChunkName: "landing" */ '@/views/content/LandingPage.vue'),
            footer: () => import(/* webpackChunkName: "footer" */ '@/components/structure/Footer'),
            topNavigation: () => import(/* webpackChunkName: "top-navigation" */ '@/components/structure/navigation/TopNavigation'),
        },
        meta: {
            order: 5,
        },
    },
];
